module.exports = __webpack_public_path__ + "img/lacava_loader.b7d6d0f7.svg";